// تبدیل اعداد فارسی به انگلیسی
export const toEnglishDigits = (str) => {
  if (!str) return '';
  
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return str
    .toString()
    .split('')
    .map((char) => {
      const persianIndex = persianDigits.indexOf(char);
      const arabicIndex = arabicDigits.indexOf(char);
      
      if (persianIndex !== -1) {
        return englishDigits[persianIndex];
      } else if (arabicIndex !== -1) {
        return englishDigits[arabicIndex];
      }
      return char;
    })
    .join('');
};

// تبدیل اعداد انگلیسی به فارسی (برای نمایش)
export const toPersianDigits = (str) => {
  if (!str && str !== 0) return '';
  
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  
  return str
    .toString()
    .replace(/[0-9]/g, (digit) => persianDigits[parseInt(digit)]);
};

// تبدیل عدد به فارسی با قالب‌بندی (با جداکننده هزارگان)
export const formatPersianNumber = (number) => {
  if (!number && number !== 0) return '';
  
  const formatted = Number(number).toLocaleString('en-US');
  return toPersianDigits(formatted);
};

// پاک کردن کاراکترهای غیرعددی (به جز ممیز و نقطه)
export const cleanNumericInput = (str) => {
  if (!str) return '';
  
  // ابتدا اعداد فارسی/عربی را به انگلیسی تبدیل می‌کنیم
  const englishStr = toEnglishDigits(str);
  
  // فقط اعداد، نقطه و منها را نگه می‌داریم
  return englishStr.replace(/[^\d.-]/g, '');
};

// تابع کمکی برای استفاده در input‌های عددی
export const handleNumericInput = (value) => {
  const cleaned = cleanNumericInput(value);
  return cleaned;
};
